"use client";

import React from "react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "EBITDA Multiples",
  description: "The primary driver of valuation. We analyze your adjusted earnings to determine the market-specific multiple your MSP commands.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668124/img/ebitda_valuation_chart.png"
}, {
  title: "Recurring Revenue Quality",
  description: "Not all revenue is equal. We evaluate the stickiness of your MRR, contract terms, and client concentration risks.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668124/img/recurring_revenue_metrics.png"
}, {
  title: "Growth Potential",
  description: "Buyers pay for the future. We highlight your scalable sales processes and untapped market opportunities to maximize value.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668124/img/msp_growth_potential.png"
}];
export default function EngineeredForExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222944" id="understanding-your-msps-value" className="bg-secondary/50 text-foreground relative w-full overflow-hidden py-24 md:py-32">
      {}
      <div className="bg-primary/5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[800px] rounded-lg blur-[120px] pointer-events-none" />

      <div ref={ref} className={`container mx-auto px-4 md:px-6 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-20">
          <h2 className="text-foreground font-default text-3xl md:text-5xl font-bold tracking-tight mb-6">
            Understanding Your MSP's Value
          </h2>
          <p className="text-muted-foreground font-default text-lg md:text-xl max-w-2xl mx-auto">
            Valuing an IT business requires more than a simple spreadsheet. We look at the core metrics that sophisticated buyers prioritize.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-20">
          {features.map((feature, i) => <div key={i} data-index={i} className="group relative rounded-2xl p-[1px] bg-border transition-all duration-500 hover:bg-gradient-to-r hover:from-primary hover:to-chart-2 hover:shadow-xl hover:shadow-primary/10">
              <Card className="bg-card backdrop-blur-xl border-none h-full flex flex-col items-center text-center p-10 transition-colors duration-500 group-hover:bg-card/80">
                <div className="mb-8 relative">
                  <div className="absolute inset-0 bg-primary/10 blur-2xl rounded-lg scale-0 transition-transform duration-500 group-hover:scale-150" />
                  <img src={feature.icon} alt={feature.title} className="w-24 h-24 object-contain relative z-10 transition-transform duration-500 group-hover:-translate-y-2" />
                </div>
                <h3 className="text-foreground font-default text-2xl font-bold mb-4">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground font-default leading-relaxed">
                  {feature.description}
                </p>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}